export const userInfo = {
  lastName: "Hunter",
  name: "Alex",
  number: "09123456789",
  profilePicture:
    "https://i.pinimg.com/236x/da/bd/70/dabd7011f523c7676c0770eeeff43df4.jpg"
};
